import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrOperationResourceItem } from '@app/services/sr-operation.service';
import { SrRefundCreateGet, SrRefundRow, SrRefundService } from '@app/services/sr-refund.service';

@Component({ selector: 'tt-sr-refund-create', templateUrl: './sr-refund-create.component.html', styleUrls: ['./sr-refund-create.component.css'], standalone: false })
export class SrRefundCreateComponent implements OnInit {
    public page?: SrRefundCreateGet;
    public resources: SrOperationResourceItem[] = [];
    public rows: SrRefundRow[] = [];
    public saving = false;
    public error = '';
    public get hasCustomer(): boolean { return Number(this.page?.cust_no) > 0; }
    constructor(private readonly refund: SrRefundService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> {
        const params = { custact_no: String(this.navigator?.params['custact_no'] ?? ''), checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? '') };
        try { await Promise.all([this.refund.getCreate(params).then(async page => { this.page = page; await Promise.all([this.loadCustomer(), this.loadRows()]); }), this.refund.getCreateResources(params).then(items => this.resources = items)]); }
        catch (error) { this.showError(error); }
    }
    public async onResourceChanged(value: string): Promise<void> {
        if (!this.page || this.page.special_resource_id_from === value) return;
        this.page.special_resource_id_from = value;
        try { await Promise.all([this.loadCustomer(), this.loadRows()]); } catch (error) { this.showError(error); }
    }
    private async loadCustomer(): Promise<void> {
        if (!this.page?.special_resource_id_from?.trim() || !this.page.custact_no?.trim()) return;
        const customer = await this.refund.getCustomer({ resource_id: this.page.special_resource_id_from, custact_no: this.page.custact_no });
        this.page.org_no = customer.org_no; this.page.cust_no = customer.cust_no; this.page.cust_name = customer.cust_name;
        this.page.cust_adr_street = customer.cust_adr_street; this.page.bankaccount = customer.bankaccount;
        this.page.send_to_resource_id = customer.send_to_resource_id; this.page.send_to_resource_name = customer.send_to_resource_name;
    }
    private async loadRows(): Promise<void> { if (!this.page || this.page.special_resource_id_from === undefined || this.page.special_resource_id_from === null) return; this.rows = []; this.rows = await this.refund.getCreateRows(this.page); }
    public openRegistry(): void { if (this.page) this.navigator?.go({ to: 'brregview', parms: { orgno: this.page.org_no, resource_id: this.page.special_resource_id_from } }); }
    public openCustomer(): void { if (this.page) this.navigator?.go({ to: 'srcustomeredit-test', parms: { cust_no: this.page.cust_no } }); }
    public async create(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const response = await this.refund.createRefund(this.page);
            if (response.errorcode !== '0') await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            else this.navigator?.back('2');
        } catch (error) { this.showError(error); }
        finally { this.saving = false; }
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
